import { render } from "./role-card-popup.vue?vue&type=template&id=6e275e86"
import script from "./role-card-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./role-card-popup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/roles/role-card-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e275e86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e275e86', __exports__)) {
    api.reload('6e275e86', __exports__)
  }
  
  module.hot.accept("./role-card-popup.vue?vue&type=template&id=6e275e86", () => {
    api.rerender('6e275e86', render)
  })

}


export default __exports__